import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensStateM } from 'pages/Liquidity/Table'
import { AlertTriangle } from 'react-feather'

import { LoadedRow, LoadingRow } from './AssetRow-m'
import { AssetListProps } from './Table'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function TokenTableM({ assetList }: AssetListProps) {
  const loadingAssets = false

  /* loading and error state */
  if (loadingAssets && !assetList) {
    return <LoadingTokenTable rowCount={5} />
  } else if (!assetList) {
    return (
      <NoTokensStateM
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading assetList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (assetList?.length === 0) {
    return <NoTokensStateM message={<Trans>No assetList found</Trans>} />
  } else {
    return (
      <>
        <TableDataContainer>
          {assetList.map((asset: any, index: number) => (
            <LoadedRow key={index} assetListIndex={index} assetListLength={assetList.length} asset={asset} />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
